// src/components/landing/Shot.jsx
import React from "react";

/*
 * Imagem responsiva (AVIF + WebP) com dimensões explícitas para evitar
 * deslocamento de layout. Por padrão é carregada só perto da tela.
 * `ui` marca uma tela real do sistema (mantém a moldura da interface).
 */
const Shot = ({
  image,
  alt,
  sizes = "100vw",
  className = "",
  eager = false,
  ui = false,
}) => (
  <picture className={className} data-ui={ui ? "" : undefined}>
    <source type="image/avif" srcSet={image.avif} sizes={sizes} />
    <source type="image/webp" srcSet={image.webp} sizes={sizes} />
    <img
      src={image.src}
      alt={alt}
      width={image.width}
      height={image.height}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      fetchPriority={eager ? "high" : undefined}
    />
  </picture>
);

export default Shot;
